import Competition from "model/Competition";
import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import { AxiosError } from "axios";
import UnauthorizedError from "api/errors/UnauthorizedError";


const deletePoints = async (competition: Competition, stage: number, token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    await apiClient.delete(`${API_URL}/points/${competition.code}/${stage}`)
    .catch((error: AxiosError) => {
        console.log(`Error deleting points for Competition(${competition.code}) and Stage(${stage})`, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default deletePoints;
